import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react'

interface MarkAsDoneContextType {
  isDone: boolean
  markedAsDone: (isDone: boolean) => void
}

const MarkAsDoneContext = createContext<MarkAsDoneContextType | null>(null)

export const MarkAsDoneProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isDone, setIsDone] = useState<boolean>(false)

  const markedAsDone = (isDone: boolean) => setIsDone(isDone)

  const contextValue = useMemo(() => ({ isDone, markedAsDone }), [isDone])

  return <MarkAsDoneContext.Provider value={contextValue}>{children}</MarkAsDoneContext.Provider>
}

export const useMarkAsDone = (): MarkAsDoneContextType => {
  const context = useContext(MarkAsDoneContext)
  if (!context) {
    throw new Error('useMarkAsDone must be used within a MarkAsDoneProvider')
  }
  return context
}
